import { View } from "react-native";

import { cn } from "@/lib/ui/cn";

/** shadcn/ui's `Skeleton` as is: Tailwind's CSS pulse, still under `prefers-reduced-motion`. */
export function Skeleton({ className }: { className?: string; }) {
  return (
    <View
      aria-hidden
      className={cn(
        "animate-pulse rounded-md bg-surface-muted motion-reduce:animate-none",
        className,
      )}
    />
  );
}
